import template from './footer.pug';
import controller from './footer.controller';

const FooterComponent = {
  template,
  controller,
};

export default FooterComponent;



// WEBPACK FOOTER //
// ./client/components/footer/footer.component.js